<p-confirmDialog key="unassign" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainGrid2Col">
	<label>Move Out Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="AssignedDate" name="AssignedDate"></p-calendar>

	<label>Assigned To:</label>
	<label>{{ StudentName }}</label>

	<label>Locker Comments/Combination:</label>
	<textarea [(ngModel)]="LockerComment" rows="5" class="TextArea"></textarea>

	<label>Assignment Comments:</label>
	<textarea [(ngModel)]="AssignmentComment" rows="5" class="TextArea"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUnassign()">Unassign</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
